import Vue from 'vue'
var bus = new Vue({
	data:{
		//监听滚动
		scroll:'',
		//监听窗口大小
		resize:''
	}
});
export default bus;



// WEBPACK FOOTER //
// ./src/bus.js